import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~env';
import { BaseDataService } from '../../../core/storage';
import { CheckoutInfo } from './checkout.model';

const useLegalEntityV3 = environment.useLegalEntityV3;
const API_URL_PLATINE = environment.legalEntityV3CommandApi;

@Injectable({
    providedIn: 'root',
})
export class CheckoutDataService {

    constructor(private dataService: BaseDataService<CheckoutInfo>,
        private translate: TranslateService,
        private http: HttpClient) { }

    get entityUrl(): string {
        return 'Payment';
    }

    /**
     *
     * @param {CheckoutInfo} info
     * @returns {Observable<any>}
     */
    sendCreditCardPayment(info: CheckoutInfo): Observable<any> {
        const lang = this.translate.currentLang;
        if (!useLegalEntityV3) {
            return this.dataService.get(
                `${this.entityUrl}/${info.societeId}/${info.amount}/${info.data_key}/${info.feeType}/${info.bin}/${info.formid}/${info.nbrEstablishment}`,
                info.permitNumber,
                `?lang=${lang}`,
            );
        } else {
            return this.http.post<any>(`${API_URL_PLATINE}/Payment/Procced?memberId=${info.memberId}`, info)
                .pipe(map((response: any) => this.parseConfirmationModel(response.content)));

        }
    }

    private parseConfirmationModel(item: any): any {
        return {
            ...item,
            result: item.transactionResult,
            abrCreditCard: item.creditCardNumber,
            numConfirmation: item.authorizationNumber,
            responseIsoCode: item.responseCode,
            sequence: item.referenceNumber,
            typeTransactionRefMoneris: item.monerisTransactionTypeRef,
            typeCarteMoneris: item.monerisCardType,
            noPermisRepondant: item.respondentPermitNumber,
            invoices: item.invoices
        };
    }
}
